import { useState } from 'react';
import { viewport } from '@telegram-apps/sdk-react';
import PropTypes from 'prop-types';
import bgImage from '@assets/images/bg.png';
import RulesDialog from '@components/dialogs/RuleDialog.component.jsx';
import { EventPreloader } from '@components/EventPreloader';
import Header from '@components/sections/Header.component.jsx';
import BottomButton from '@components/ui/BottomButton/BottomButton';

export default function EventLayout({
  footerText,
  showPreloader,
  secondaryButtonParams = {
    text: 'Text',
    isEnabled: false,
    isVisible: false,
  },
  mainButtonParams = {
    text: 'Text',
    isEnabled: false,
    isVisible: false,
  },
  children,
}) {
  const [isRuleDialogOpen, setIsRuleDialogOpen] = useState(false);
  const safeAreaBottom =
    viewport.contentSafeAreaInsetBottom() + viewport.safeAreaInsetBottom() ||
    '45px';

  const isBottomBarVisible =
    mainButtonParams.isVisible || secondaryButtonParams.isVisible;

  // const gradient = `
  //   linear-gradient(
  //      135deg,
  //      #1e6b89 0%,
  //      #184864 40%,
  //      #123c54 70%,
  //      #0d1f3a 100%
  //     )`;

  // useMainButton(mainButtonParams, hideButtonsImmediately, isRuleDialogOpen);
  // useSecondaryButton(
  //   secondaryButtonParams,
  //   hideButtonsImmediately,
  //   isRuleDialogOpen,
  //   () => setIsRuleDialogOpen(true),
  // );

  return (
    <>
      <EventPreloader isLoading={showPreloader} />
      <RulesDialog
        open={isRuleDialogOpen}
        onClose={() => setIsRuleDialogOpen(false)}
      />
      <div
        className="min-h-screen max-h-vh bg-cover bg-center bg-no-repeat bg-fixed"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundAttachment: 'fixed',
          backdropFilter: 'blur(50px)',
          WebkitBackdropFilter: 'blur(50px)',
          backgroundBlendMode: 'overlay',
          backgroundColor: 'rgba(0, 0, 0, .15)',
          paddingTop: viewport.safeAreaInsetTop(),
          paddingBottom: viewport.contentSafeAreaInsetBottom(),
        }}
      >
        <Header />
        <main
          className="container mx-auto max-h-[78vh] overflow-auto justify-center items-center"
          style={{
            paddingTop: viewport.safeAreaInsetTop() / 2,
            paddingBottom: viewport.contentSafeAreaInsetBottom(),
          }}
        >
          <div className="text-center w-full px-2.5">{children}</div>
        </main>
        {footerText && (
          <div className="text-center mx-2.5 mt-3 mb-1">
            <p
              className={
                'text-event-text text-base font-medium font-sans break-words'
              }
            >
              {footerText}
            </p>
          </div>
        )}

        <div className="test"></div>
        <footer
          hidden={!isBottomBarVisible}
          className="fixed bottom-0 flex flex-row justify-between items-center px-2 pb-2 gap-2 w-full"
          style={{ paddingBottom: safeAreaBottom }}
        >
          <BottomButton
            {...secondaryButtonParams}
            onClick={() => setIsRuleDialogOpen(true)}
            type={'secondary'}
          />

          <BottomButton
            {...mainButtonParams}
            type={'primary'}
            shineEffect={true}
          />
        </footer>
      </div>
    </>
  );
}

EventLayout.propTypes = {
  children: PropTypes.node.isRequired,
  showPreloader: PropTypes.bool.isRequired,
  mainButtonParams: PropTypes.shape({
    text: PropTypes.string,
    isEnabled: PropTypes.bool,
    isVisible: PropTypes.bool,
    onClick: PropTypes.func,
  }),
};
